import React, {useEffect} from 'react';
import {ThemeProvider} from 'styled-components';
import {Router} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';

import history from './services/Navigate/history';
import Routes from './routes';
import GlobalStyle from './styles/global';
import theme from './styles/theme';
import '../node_modules/react-toastify/dist/ReactToastify.css';

function App() {

    useEffect(() => {
        const signed = localStorage.getItem('@user_token');

      const currentPath = window.location.pathname;

      if (!signed && !(
            currentPath === '/login' ||
            currentPath === '/register' ||
            currentPath === '/' ||
            currentPath === ''
        )) {
            window.location.href = '/login';
        }
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <Router history={history}>
                <Routes />
            </Router>
            <ToastContainer />
            <GlobalStyle />
        </ThemeProvider>
    );
}

export default App;
